export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.client) return

  nuxtApp.vueApp.config.warnHandler = (msg, instance, trace) => {
    const skipWarnings = []
    if (skipWarnings.some((warning) => msg.includes(warning))) return

    const skipComponents = [
      //
      "Media",
      "MediaItem",
    ]
    if (skipComponents.some((component) => trace.includes(`<${component}>`)))
      return

    console.warn("[Vue warn]: ".concat(msg).concat(trace))
  }
})
